import React, { useEffect, useState } from 'react';
import { Button, Card, Col, Form, FormControl, Row } from 'react-bootstrap';
import PropTypes from 'prop-types';
import { ApiEndpoint } from 'helpers/ApiEndPoint.js';
import { useAuth } from 'context/AuthProvider.js';
import { httpClient } from 'helpers/HttpClient.js';
import { useForm } from 'react-hook-form';
const URI = ApiEndpoint + 'configuration/';
const EditNom = ({ idNom, closeModal }) => {
  const Auth = useAuth();
  var userData = Auth.getSessionData();
  const [nom, setNom] = useState({
    clave: '',
    titulo: '',
    descripcion: '',
    esvigente: 'true'
  });
  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors }
  } = useForm();
  const getNom = async () => {
    setNom(null);

    httpClient('GET', URI + 'noms/' + idNom, {}, userData.token)
      .then(function (response) {
        if (!response.data.error) {
          setValue('clave', response.data.clave);
          setValue('titulo', response.data.titulo);
          setValue('descripcion', response.data.descripcion);
          setValue('esvigente', response.data.esvigente);
        }
      })
      .catch(function (error) {
        console.log(error);
      })
      .finally(() => {});
  };
  useEffect(() => {
    if (idNom > 0) getNom();
  }, []);
  const onSubmit = data => {
    console.log(data);

    if (idNom > 0) {
      httpClient(
        'put',
        URI + 'noms/' + idNom,
        {
          descripcion: data.descripcion,
          clave: data.clave,
          titulo: data.titulo,
          esvigente: data.esvigente
        },
        userData.token
      )
        .then(function (response) {
          if (!response.data.error) {
            closeModal();
          }
        })
        .catch(function (error) {
          console.log(error);
        })
        .finally(() => {});
    } else {
      httpClient(
        'POST',
        URI + 'noms',
        {
          descripcion: data.descripcion,
          clave: data.clave,
          titulo: data.titulo,
          esvigente: data.esvigente
        },
        userData.token
      )
        .then(function (response) {
          if (!response.data.error) {
            closeModal();
          }
        })
        .catch(function (error) {
          console.log(error);
        })
        .finally(() => {});
    }
  };
  return (
    <Card style={{ width: '100%' }}>
      <Card.Body>
        <Form onSubmit={handleSubmit(onSubmit)}>
          <Row>
            <Col>
              <Form.Group className="mb-4">
                <Form.Label>Clave</Form.Label>
                <FormControl
                  {...register('clave', {
                    required: 'Clave es requerido',
                    minLength: {
                      value: 3,
                      message: 'Clave debe tener al menos 4 caracteres'
                    },
                    maxLength: {
                      value: 30,
                      message: 'Clave debe tener al menos 30 caracteres'
                    }
                  })}
                  type="text"
                  defaultValue={nom?.clave}
                  isInvalid={!!errors.clave}
                />
                <Form.Control.Feedback type="invalid">
                  {errors.clave?.message}
                </Form.Control.Feedback>
              </Form.Group>
            </Col>
          </Row>
          <Row>
            <Col>
              <Form.Group className="mb-4">
                <Form.Label>Titulo</Form.Label>
                <FormControl
                  {...register('titulo', {
                    required: 'Titulo es requerido',
                    minLength: {
                      value: 3,
                      message: 'Titulo debe tener al menos 4 caracteres'
                    },
                    maxLength: {
                      value: 30,
                      message: 'Titulo debe tener máximo 100 caracteres'
                    }
                  })}
                  type="text"
                  defaultValue={nom?.titulo}
                  isInvalid={!!errors.titulo}
                />
                <Form.Control.Feedback type="invalid">
                  {errors.titulo?.message}
                </Form.Control.Feedback>
              </Form.Group>
            </Col>
          </Row>
          <Row>
            <Col>
              <Form.Group className="mb-4">
                <Form.Label>Descripcion</Form.Label>
                <FormControl
                  {...register('descripcion', {
                    required: 'Descripcion es requerido',
                    minLength: {
                      value: 3,
                      message: 'Descripcion debe tener al menos 4 caracteres'
                    },
                    maxLength: {
                      value: 30,
                      message:
                        'Descripcion debe tener como máximo 100 caracteres'
                    }
                  })}
                  type="text"
                  defaultValue={status?.descripcion}
                  isInvalid={!!errors.descripcion}
                />
                <Form.Control.Feedback type="invalid">
                  {errors.descripcion?.message}
                </Form.Control.Feedback>
              </Form.Group>
            </Col>
          </Row>

          <Row>
            <Col>
              <Col>
                <Form.Group className="mb-4">
                  <Form.Check // prettier-ignore
                    type="checkbox"
                    id={`esvigente`}
                    {...register('esvigente')}
                    label={`Es vigente`}
                    name="esvigente"
                  />
                </Form.Group>
              </Col>
            </Col>
          </Row>
          <Row>
            <Col>
              <Button type="submit" color="primary" size="sm">
                Guardar
              </Button>
            </Col>
          </Row>
        </Form>
      </Card.Body>
    </Card>
  );
};
EditNom.propTypes = {
  idNom: PropTypes.number.isRequired,
  closeModal: PropTypes.func.isRequired
};
export default EditNom;
